import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod/v3';

import { grirMainRoute } from '..';
import { grirDetailSearchSchema } from './schemas';

export const grirDetailRoute = createRoute({
  getParentRoute: () => grirMainRoute,
  path: '$caseId',
  component: lazyRouteComponent(() => import('./GrirDetailView')),
  parseParams: (params) => ({
    caseId: z.string().parse(params.caseId),
  }),
  validateSearch: grirDetailSearchSchema,
});
